import { render, staticRenderFns } from "./3cx.vue?vue&type=template&id=66a16e84&scoped=true&"
import script from "./3cx.vue?vue&type=script&lang=js&"
export * from "./3cx.vue?vue&type=script&lang=js&"
import style0 from "./3cx.vue?vue&type=style&index=0&id=66a16e84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a16e84",
  null
  
)

export default component.exports